<template>
    <div id="page-text-fields">
        <v-container fluid grid-list-xl v-if="show_page">
            <v-form @submit.prevent="handleSubmit" ref="form">
                <v-layout row wrap>
                    <v-flex sm12>
                        <v-widget title="اطلاعات محصول">
                            <div slot="widget-content">
                                <v-container>
                                    <v-layout v-if="image !== null">
                                        <v-flex style="text-align: center;" class="chess-bg">
                                            <img :style="`max-height: 400px;margin:0 auto;background: rgba(`+form.artwork_color.rgba.r+`,`+form.artwork_color.rgba.g+`,`+form.artwork_color.rgba.b+`,`+form.artwork_color.rgba.a+`);` + (dbh.adult_content?`box-shadow: red 10px 10px;`:``)"
                                                 src="`https://chapchi.com/reseller_privates/org_artworks/`">
                                        </v-flex>
                                    </v-layout>


                                    <v-layout class="text-xs-center justify-center px-2">
                                        <v-flex xs6>
                                            <v-dialog v-model="bg_color_modal" persistent max-width="300px">
                                                <v-btn color="blue" class="white--text" block
                                                       slot="activator">
                                                    <v-icon dark>colorize</v-icon>
                                                    &nbsp;
                                                    انتخاب رنگ زمینه نمایش طرح

                                                </v-btn>
                                                <v-card>
                                                    <v-card-title>
                                                        <span class="headline">انتخاب رنگ</span>
                                                        <v-spacer></v-spacer>
                                                        <v-btn color="blue darken-1" flat icon=""
                                                               @click.native="bg_color_modal = false">
                                                            <v-icon>close</v-icon>
                                                        </v-btn>
                                                    </v-card-title>
                                                    <v-divider></v-divider>
                                                    <v-card-text>
                                                        <v-container grid-list-md>
                                                            <v-flex>
                                                                <color-picker v-model="form.artwork_color"></color-picker>
                                                            </v-flex>
                                                        </v-container>
                                                    </v-card-text>
                                                </v-card>
                                            </v-dialog>
                                        </v-flex>
                                        <v-flex xs6>
                                            <v-dialog v-model="pr_color_modal" persistent max-width="300px">
                                                <v-btn color="blue" class="white--text" block
                                                       slot="activator">
                                                    <v-icon dark>colorize</v-icon>
                                                    &nbsp;
                                                    انتخاب رنگ زمینه نمایش محصول

                                                </v-btn>
                                                <v-card>
                                                    <v-card-title>
                                                        <span class="headline">انتخاب رنگ</span>
                                                        <v-spacer></v-spacer>
                                                        <v-btn color="blue darken-1" flat icon=""
                                                               @click.native="pr_color_modal = false">
                                                            <v-icon>close</v-icon>
                                                        </v-btn>
                                                    </v-card-title>
                                                    <v-divider></v-divider>
                                                    <v-card-text>
                                                        <v-container grid-list-md>
                                                            <v-flex>
                                                                <color-picker v-model="form.product_color"></color-picker>
                                                            </v-flex>
                                                        </v-container>
                                                    </v-card-text>
                                                </v-card>
                                            </v-dialog>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout>
                                        <v-flex sm6>
                                            <v-text-field
                                                    label="نام محصول"
                                                    name="name"
                                                    type="text"
                                                    v-model="form.name"
                                                    required
                                                    :rules="[rules.required]"
                                            ></v-text-field>
                                        </v-flex>
                                        <v-flex sm6>
                                            <v-combobox
                                                    multiple
                                                    label="کلمات کلیدی (جدا کردن با اینتر)"
                                                    name="tags"
                                                    type="text"
                                                    v-model="form.tags"
                                                    :rules="[rules.required]"
                                            ></v-combobox>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout>
                                        <v-flex sm12>
                                            <label>توضیحات</label>
                                            <v-textarea placeholder="توضیحات"
                                                        maxlength="2048"
                                                        v-model="form.description"></v-textarea>
                                        </v-flex>
                                    </v-layout>

                                    <v-layout row>
                                        <v-flex
                                                v-bind:key="`cat_` + id"
                                                v-for="(cat,id) in getSubMpCats(0)">
                                            <v-autocomplete
                                                    :items="getSubMpCats(cat.m_cat_id)"
                                                    item-text="cat_name"
                                                    item-value="m_cat_id"
                                                    multiple
                                                    :label="cat.cat_name"
                                                    :name="cat.cat_name"
                                                    v-model="form.marketplace"
                                            ></v-autocomplete>
                                        </v-flex>
                                    </v-layout>

                                </v-container>
                            </div>
                        </v-widget>
                    </v-flex>

                </v-layout>

                <v-divider></v-divider>

                <v-layout row wrap>
                    <v-flex sm4 v-for="bf in blanks_families" v-bind:key="`bff_`+bf.id">
                        <v-text-field
                                :label="bf.family_name"
                                :name="bf.family_name"
                                type="number"
                                v-model.number="form.commissions[bf.id]"
                        ></v-text-field>
                    </v-flex>
                </v-layout>
                <v-divider></v-divider>
                <v-list three-line subheader>
                    <v-subheader> رنگ‌های فعال برای خانواده‌ی تیشرت</v-subheader>
                    <CircleColor
                            :key="bc.cf_id"
                            v-for="bc in blanks_color_families"
                            v-model="form.colors"
                            :bc="bc"
                            @ColorChange="changeColor"
                            style="display: inline-block"
                    ></CircleColor>
                </v-list>
                <v-container>
                    <v-layout>
                        <v-flex>
                            <v-btn
                                    :disabled="loading"
                                    :loading="loading"
                                    class="white--text"
                                    color="red"
                                    large
                                    @click="isNotGood"
                            >
                                <v-icon dark right>close</v-icon>
                                خوب نیست، نشان نده&nbsp;
                                <v-icon dark right>close</v-icon>
                            </v-btn>
                        </v-flex>
                        <v-flex>
                            <v-btn
                                    :disabled="loading"
                                    :loading="loading"
                                    class="white--text"
                                    color="green"
                                    large
                                    type="button"
                                    @click="handleSubmit"
                            >
                                <v-icon dark right>save</v-icon>
                                &nbsp;
                                ثبت
                                &nbsp;
                                <v-icon dark right>save</v-icon>
                            </v-btn>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-form>
        </v-container>
        <v-container fluid grid-list-xl v-else>
            <v-card>
                <v-layout row wrap>
                    <v-flex sm12 style="padding: 50px">
                درحال بارگذاری...
                    </v-flex>
                </v-layout>
            </v-card>
        </v-container>
        <v-snackbar
                :bottom="snackbar.y === 'bottom'"
                :color="snackbar.color"
                :left="snackbar.x === 'left'"
                :multi-line="snackbar.mode === 'multi-line'"
                :right="snackbar.x === 'right'"
                :timeout="snackbar.timeout"
                :top="snackbar.y === 'top'"
                :vertical="snackbar.mode === 'vertical'"
                v-model="snackbar.snackbar"
        >
            {{ snackbar.text }}
            <v-btn @click.native="snackbar.snackbar = false" dark flat icon>
                <v-icon>close</v-icon>
            </v-btn>
        </v-snackbar>
    </div>
</template>
<script>
import VWidget from '@/components/VWidget';

import HttpErrorToSnackbar from '@/api/HttpErrorToSnackbar';
import CircleColor from '../../components/widgets/color/CircleColor';
import { Sketch } from 'vue-color';
export default {
  components: {
    VWidget,
    ColorPicker: Sketch,
    CircleColor
  },
  data () {
    return {
      editorOption: {},
      bg_color_modal: false,
      pr_color_modal: false,
      snackbar: {
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: 'multi-line',
        timeout: 6000,
        color: 'error',
        text: ''
      },
      image: null,
      stores: [],
      marketplaceCategories: [],
      form: {
        name: '',
        description: '',
        tags: [],
        marketplace: [],
        colors: [],
        adult_content: false,
        artwork_color: { hex: '', rgba: { r: 0, g: 0, b: 0, a: 0 }},
        product_color: { hex: '', rgba: { r: 0, g: 0, b: 0, a: 0 }},
        commissions: {},
      },
      loader: null,
      loading: false,
      show_page: true,
      rules: {
        required: (value) => !!value || 'پر کردن این فیلد اجباری است.',
      },
      blanks_color_families: [],
      blanks_families: [],
      family_defaults: [0, 37, 90, 80, 0, 50, 50, 60, 60, 50, 50, 50, 50, 50],
    };
  },
  computed: {},
  watch: {
    loader () {
      const l = this.loader;
      this[l] = !this[l];
      setTimeout(() => {
        this[l] = false;
      }, 3000);
      this.loader = null;
    }
  },
  mounted: function () {
    this.axios.get('/reseller/blank_families/')
      .then(response => {
        response.data.Data.forEach((rd) => {
          let item = 0;
          if (typeof this.family_defaults[rd.id] !== 'undefined' && this.family_defaults[rd.id] > 0) {
            item = this.family_defaults[rd.id];
          } else {
            item = rd.default_commission;
          }
          this.form.commissions[rd.id] = item;
        });
        this.blanks_families = response.data.Data;
      }).catch(error => {
        this.snackbar = HttpErrorToSnackbar(error);
      });
    
    this.axios.get('/reseller/stores/')
      .then(response => {
        this.stores = response.data.Data;
      }).catch(error => {
        this.snackbar = HttpErrorToSnackbar(error);
      });

    // get Categories Data
    this.axios.get('/reseller/blanks_color_families/')
      .then(response => {
        response.data.Data.forEach(bcf => {
          this.form.colors.push(bcf.cf_id);
        });
        this.blanks_color_families = response.data.Data;
      }).catch(err => {
        this.snackbar = HttpErrorToSnackbar(err);
      });

    // get Categories Data
    this.axios.get('/reseller/marketplace_categories/')
      .then(response => {
        this.marketplaceCategories = response.data.Data;
      }).catch(err => {
        this.snackbar = HttpErrorToSnackbar(err);
      });


  },
  methods: {
    changeColor (opts) {
      this.form.colors = opts;
    },
    updateArtColorValue (val) {
      console.log(val);
      this.form.artwork_color = val.rgba;
    },
    updateProductColorValue (val) {
      this.form.product_color = val;
    },
    getSubMpCats (parent_id) {
      return this.marketplaceCategories.filter(mp => mp.parent_id === parent_id);
    },
    handleSubmit () {
      let isValidate = this.$refs.form.validate();
      if (!isValidate) {
        this.snackbar.snackbar = true;
        this.snackbar.color = 'red';
        this.snackbar.text = 'موارد ضروری را پر نمایید';
        return;
      }
      this.loader = 'loading';
      const data = Object.assign({}, this.form);
      data.tags = data.tags.join(',');
      data.art_id = Number(this.$route.params.id);
      data.artwork_color = data.artwork_color.rgba;
      data.product_color = data.product_color.rgba;

      if (data.artwork_color.a > 0 && data.artwork_color.a <= 1) {
        data.artwork_color.a = Math.round(255 * data.artwork_color.a);
      }

      if (data.product_color.a > 0 && data.product_color.a <= 1) {
        data.product_color.a = Math.round(255 * data.product_color.a);
      }

      this.axios.post('/reseller/magic_submit', data)
        .then(response => {
          // Response Submit Method
          console.log(response);
          this.snackbar.text = 'با موفقیت انجام شد.';
          this.snackbar.y = 'bottom';
          this.snackbar.color = 'success';
          this.snackbar.snackbar = true;
          this.loading = false;
        })
        .catch(error => {
          this.snackbar = HttpErrorToSnackbar(error);
          this.loading = false;
        });

    },
  }
};
</script>
<style lang="stylus" scoped>

    .chess-bg
        background-image:
                linear-gradient(90deg, #9e9e9e 30px, white 30px),
                linear-gradient(90deg, white 30px, #9e9e9e 30px),
                linear-gradient(90deg, #9e9e9e 30px, white 30px),
                linear-gradient(90deg, white 30px, #9e9e9e 30px),
                linear-gradient(90deg, #9e9e9e 30px, white 30px),
                linear-gradient(90deg, white 30px, #9e9e9e 30px),
                linear-gradient(90deg, #9e9e9e 30px, white 30px),
                linear-gradient(90deg, white 30px, #9e9e9e 30px),
                linear-gradient(90deg, #9e9e9e 30px, white 30px),
                linear-gradient(90deg, white 30px, #9e9e9e 30px),
                linear-gradient(90deg, #9e9e9e 30px, white 30px),
                linear-gradient(90deg, white 30px, #9e9e9e 30px),
                linear-gradient(90deg, #9e9e9e 30px, white 30px),
                linear-gradient(90deg, white 30px, #9e9e9e 30px),
                linear-gradient(90deg, #9e9e9e 30px, white 30px),
                linear-gradient(90deg, white 30px, #9e9e9e 30px),
                linear-gradient(90deg, #9e9e9e 30px, white 30px),
                linear-gradient(90deg, white 30px, #9e9e9e 30px),
                linear-gradient(90deg, #9e9e9e 30px, white 30px),
                linear-gradient(90deg, white 30px, #9e9e9e 30px),
                linear-gradient(90deg, #9e9e9e 30px, white 30px),
                linear-gradient(90deg, white 30px, #9e9e9e 30px),
                linear-gradient(90deg, #9e9e9e 30px, white 30px),
                linear-gradient(90deg, white 30px, #9e9e9e 30px),
                linear-gradient(90deg, #9e9e9e 30px, white 30px),
                linear-gradient(90deg, white 30px, #9e9e9e 30px),
                linear-gradient(90deg, #9e9e9e 30px, white 30px),
                linear-gradient(90deg, white 30px, #9e9e9e 30px),
                linear-gradient(90deg, #9e9e9e 30px, white 30px),
                linear-gradient(90deg, white 30px, #9e9e9e 30px),
                linear-gradient(90deg, #9e9e9e 30px, white 30px),
                linear-gradient(90deg, white 30px, #9e9e9e 30px),
                linear-gradient(90deg, #9e9e9e 30px, white 30px),
                linear-gradient(90deg, white 30px, #9e9e9e 30px),
                linear-gradient(90deg, #9e9e9e 30px, white 30px),
                linear-gradient(90deg, white 30px, #9e9e9e 30px),
                linear-gradient(90deg, #9e9e9e 30px, white 30px),
                linear-gradient(90deg, white 30px, #9e9e9e 30px),
                linear-gradient(90deg, #9e9e9e 30px, white 30px),
                linear-gradient(90deg, white 30px, #9e9e9e 30px),
                linear-gradient(90deg, #9e9e9e 30px, white 30px);
        background-position: 0 0, 0 30px, 0 60px, 0 90px, 0 120px, 0 150px,
        0 180px, 0 210px, 0 240px, 0 270px, 0 300px, 0 330px, 0 360px, 0 390px;
        background-repeat: repeat-x;
        background-size: 60px 30px;

</style>



// WEBPACK FOOTER //
// src/pages/magic/add.vue